<template>
    <div class="loginBox" v-loading="true" element-loading-text="登录中……"></div>
    </template>
    <script>
    import ss from '../api/SystemService'
    import { jsonp } from 'vue-jsonp'
    import store from "../store";
    import system from "@/utils/system";

    export default {
        data() {
            return {
                url :""
            }
        },
        mounted() {
        },
      created() {
        this.getUrlCode();
      },
      methods: {
          getUrlCode() {

            var query=this.$route.query;

            var url = window.location.href;      //获取当前url
            this.url = url.split('url=')[1];

              //获取本缓存accessToken
              var accessToken= null;
              accessToken = localStorage.getItem("accessToken");


              //判断是否访问单点登录路径
            if (url.indexOf("code") == -1 && url.indexOf("access_token=") == -1 && accessToken == null) {
                console.log("lqurl="+this.url)
                let decodedParam = decodeURIComponent(this.url);
                let urlLq = decodedParam.startsWith('/') ? decodedParam.substring(1) : decodedParam;
                console.log("urlLq="+urlLq)

                ss.LoginService.getUrlByLq(urlLq,url).then(rd => {
                    window.location.href = rd
                })
            }



            //判断url是否携带参数
            if (url.indexOf('?') != -1 || accessToken!=null) {

              var dz_url = url.split('#')[0];        //获取#/之前的字符串
                console.log("dz_url",dz_url)

              var cs = url.split('?')[1];        //获取?之后的参数字符串
                console.log("cs",cs)
              var cs_arr=[];

              if(cs != null && cs != undefined){
                cs_arr = cs.split('&');          //参数字符串分割为数组
              }

              var cs = {};

              for (var i = 0; i < cs_arr.length; i++) {    //遍历数组，拿到json对象
                cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
              }

                console.log("33333333333",cs)
                console.log("url",url)
                console.log("state1",url.split('url=')[1])
              var code = cs.code;
              var state = null;
              var access_token = cs.access_token
              if(url.indexOf("access_token") != -1 && null != access_token && undefined !=access_token){
                state = cs.url;
                ss.LoginService.getSsoLoginByLq(access_token,state,null).then(rd => {
                  if(rd.f == false){
                    window.location.href = rd.msg
                  }else {
                    store.commit("setUser", rd)
                    this.loading = false;
                    this.$router.push({path: rd.obj.defaultpage});
                  }
                })

              }else if((url.indexOf("code") != -1 && null != code && undefined !=code) || accessToken!=null){
                  console.log("4444444",cs)
                  console.log("code",cs.code)

                  state = cs.state;

                  if(cs.ssoLogin){
                      state =  url.split('url=')[1]
                  }
                ss.LoginService.getSsoLoginByLq(accessToken,state,code).then(rd => {
                  if(rd.f == true){
                    store.commit("setUser", rd)
                    this.loading = false;
                      //缓存accessToken
                      localStorage.setItem("accessToken", rd.obj.accessToken);

                      this.$router.push({path: rd.obj.defaultpage});
                  }else{
                      //删除accessToken
                      localStorage.removeItem("accessToken");
                      this.$msg.msge("统一认证失败,请重新登录!")
                      this.$router.push({path: "ssoLogin"});
                  }
                })
              }

            }

            //如果localStorage中有accessToken
            if(accessToken!=null){

                ss.LoginService.getSsoLoginByLq(accessToken,this.url,null).then(rd => {
                    if(rd.f == true){
                        store.commit("setUser", rd)
                        this.loading = false;
                        //缓存accessToken
                        localStorage.setItem("accessToken", rd.obj.accessToken);

                        this.$router.push({path: rd.obj.defaultpage});
                    }else{
                        //删除accessToken
                        localStorage.removeItem("accessToken");
                        this.$msg.msge("统一认证失败,请重新登录!")
                        this.$router.replace('/empty').then(() => {
                            this.$router.replace(this.$route.path)
                        })
                    }
                })

            }


          },

        },
    }
    </script>
<style scoped media="screen">

    .loginBox {
        width: 100%;
        height: 100%;
        background: url(../assets/images/login-bg.jpg) center/cover;
        position: relative;
    }
</style>
